import { REGEX_EMPTY_SPACE } from '../constants/regex-constants'

export default (val: string) => val.toUpperCase().replace(REGEX_EMPTY_SPACE, '')
